import { useGetUserIdMutation, useSearchUsersQuery } from '@app/services';
import { isValidEmail } from '@common';
import { Errors } from '@common';
import { MPAlert, MPAutoComplete, MPButton, MPInput } from '@components';
import { Col, Form, Input, Row, Space } from 'antd';
import React, { useState } from 'react';
import Styles from './Styles.module.scss';

export default function EmailForm() {
    const [value, setValue] = useState<string>();
    const form = Form.useFormInstance();
    const { data: users } = useSearchUsersQuery(value || '', { skip: !value });
    const [internalError, setInternalError] = useState<string>();

    const handleClick = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        try {
            e.preventDefault();
            setInternalError(undefined);

            if (!value || !isValidEmail(value)) throw new Error(Errors.invalidEmail);

            const user = users?.find(user => user.email === value);

            if (!user) throw new Error('User not found');

            const permissions = form.getFieldValue(['accessManagement', 'permissions']) || [];

            if (permissions?.find((item: any) => item.user === user.id)) throw new Error(Errors.emailExists);

            form.setFieldValue(
                ['accessManagement', 'permissions'],
                [
                    ...permissions,
                    {
                        email: user.email,
                        user: user.id,
                        access: [],
                        userInfo: user,
                    },
                ]
            );

            setValue(undefined);
        } catch (error: any) {
            console.error(error);
            setInternalError(error?.message);
        }
    };

    return (
        <Row>
            <Col span={8}>
                <Space.Compact style={{ marginBottom: 20, display: 'flex' }}>
                    <MPAutoComplete
                        options={users?.map(user => ({ label: user.email, value: user.email }))}
                        value={value}
                        onChange={e => setValue(e)}
                        style={{ flex: 1 }}
                        placeholder="User Email"
                    />
                    <MPButton
                        htmlType="submit"
                        type="primary"
                        onClick={handleClick}
                    >
                        Add User
                    </MPButton>
                </Space.Compact>

                {internalError && (
                    <MPAlert
                        message={internalError}
                        type="error"
                        className={Styles.Alert}
                    />
                )}
            </Col>
        </Row>
    );
}
